import React from 'react';
import Cart from '~/components/cart/Cart';
import CartStructuredData from '~/components/meta/structured-data/CartStructuredData';
import { Container } from '~/components/layout/PageStructure';
import ExpiryTimer from '~/components/cart/ExpiryTimer';
import PageTitle from '~/components/modules/pageTitle';
import SEO from '~/components/meta/SEO';
import { useSiteContext } from '~/context/SiteContext';
import { useCart } from '~/context/CartContext';

const CartPage = () => {
  const { shopInfo } = useSiteContext().globals;
  const { cart: currentCart } = useCart();
  const title = 'Your cart';

  return (
    <>
      <SEO title={title} />
      <Container>
        <ExpiryTimer
          className="mt-5 mb-6 text-center"
          expiresAt={currentCart?.freeShippingUntil}
          countdownPrefix="Free shipping if you pay within:"
          expiredText={'Free shipping is expired'}
        />
      </Container>
      <PageTitle title={title} textAlign="left" />
      <div className="mb-7">
        {currentCart?.items?.length || currentCart?.waitlistItems?.length ? (
          <Cart cart={currentCart} shop={shopInfo} />
        ) : (
          <Container className="mb-9">
            <p>Your cart is empty.</p>
          </Container>
        )}
      </div>

      <CartStructuredData url={window.location.href} title={title} />
    </>
  );
};

export default CartPage;
